import { render } from "./CommonCodes.vue?vue&type=template&id=3ca6b14f&scoped=true"
import script from "./CommonCodes.vue?vue&type=script&lang=js"
export * from "./CommonCodes.vue?vue&type=script&lang=js"

import "./CommonCodes.vue?vue&type=style&index=0&id=3ca6b14f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ca6b14f"]])

export default __exports__